module.exports = __webpack_public_path__ + "img/170.b768d710.jpg";